import React, { useState } from "react";
import CustomBg from "../Components/CustomBg";
import solIcon from "../assets/sol-image.png";
import sadcoonImage from "../assets/left-content-bottom-img.png";
import { handleCopy } from "../utils/copyToClipboard";
import { holderDistributions, user } from "../constants";
import CommentModal from "../Components/Modal/CommentModal";
import { Link } from "react-router-dom";

const CoinDetails = ({ showModal }) => {
  const [activeTab, setActiveTab] = useState("Thread");

  return (
    <div className="detail-coin">
      <div className="custom-bg">
        <h1 className="title">Candle Stick Graph</h1>
      </div>

      <div className="navgate-btn">
        <div className="nav-buttons">
          <button
            className={`nav-button ${activeTab === "Thread" ? "active" : ""}`}
            onClick={() => setActiveTab("Thread")}
          >
            Thread
          </button>
          <button
            className={`nav-button ${activeTab === "Trades" ? "active" : ""}`}
            onClick={() => setActiveTab("Trades")}
          >
            Trades
          </button>
        </div>
        <div className="second">
          <button className="reply-post" onClick={() => showModal(true)}>
            <img src="/icons/refresh.svg" alt="" />
            Post a Reply
          </button>
        </div>
      </div>
      <div className="filters">
        <div className="filter-item">
          <label className="filter-label" htmlFor="following">
            Filter by Following
          </label>
          <input className="toggle-switch" type="checkbox" id="following" />
        </div>

        <div className="filter-item">
          <label className="filter-label" htmlFor="size">
            Filter by Size
          </label>

          <span className="filter-description">
            <span className="coin-icon"></span> 0.05 (trades of size greater
            than 0.05 SOL)
            <input className="toggle-switch" type="checkbox" id="size" />
          </span>
        </div>
      </div>
      {activeTab === "Trades" && (
        <div className="table-section">
          <table className="data-table">
            <thead>
              <tr>
                <th>Account</th>
                <th>Type</th>
                <th>SOL</th>
                <th>QAI</th>
                <th>Date</th>
                <th>Transaction</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>shinobiTR</td>
                <td>Buy</td>
                <td>4.581</td>
                <td>11.6m</td>
                <td>Dec 3 10:33:37 am</td>
                <td>3Myzc</td>
              </tr>
              <tr>
                <td>shinobiTR</td>
                <td>Sell</td>
                <td>4.581</td>
                <td>11.6m</td>
                <td>Dec 3 10:33:37 am</td>
                <td>57nk</td>
              </tr>
              <tr>
                <td>shinobiTR</td>
                <td>Sell</td>
                <td>4.581</td>
                <td>11.6m</td>
                <td>Dec 3 10:33:37 am</td>
                <td>57nk</td>
              </tr>
              <tr>
                <td>cryptoKing</td>
                <td>Buy</td>
                <td>3.245</td>
                <td>8.9m</td>
                <td>Dec 3 11:15:20 am</td>
                <td>2Bjhd</td>
              </tr>
              <tr>
                <td>blockHunter</td>
                <td>Sell</td>
                <td>2.984</td>
                <td>10.2m</td>
                <td>Dec 3 11:45:10 am</td>
                <td>7Lpqa</td>
              </tr>
              <tr>
                <td>traderJoe</td>
                <td>Buy</td>
                <td>5.124</td>
                <td>15.0m</td>
                <td>Dec 3 12:03:22 pm</td>
                <td>9Mkwq</td>
              </tr>
              <tr>
                <td>chainMaster</td>
                <td>Sell</td>
                <td>6.872</td>
                <td>20.5m</td>
                <td>Dec 3 12:35:50 pm</td>
                <td>3Qlpd</td>
              </tr>
              <tr>
                <td>nodeRunner</td>
                <td>Buy</td>
                <td>1.234</td>
                <td>4.5m</td>
                <td>Dec 3 01:00:15 pm</td>
                <td>8Pqks</td>
              </tr>
              <tr>
                <td>alphaWolf</td>
                <td>Sell</td>
                <td>3.675</td>
                <td>9.8m</td>
                <td>Dec 3 01:30:10 pm</td>
                <td>6Njkd</td>
              </tr>
              <tr>
                <td>moonChaser</td>
                <td>Buy</td>
                <td>2.850</td>
                <td>7.6m</td>
                <td>Dec 3 02:10:05 pm</td>
                <td>4Rmtk</td>
              </tr>
              <tr>
                <td>cryptoAce</td>
                <td>Sell</td>
                <td>4.912</td>
                <td>13.4m</td>
                <td>Dec 3 02:45:30 pm</td>
                <td>5Cqws</td>
              </tr>
              <tr>
                <td>altCoiner</td>
                <td>Buy</td>
                <td>6.000</td>
                <td>18.0m</td>
                <td>Dec 3 03:00:45 pm</td>
                <td>1Btkz</td>
              </tr>
              <tr>
                <td>stableScout</td>
                <td>Sell</td>
                <td>3.111</td>
                <td>10.1m</td>
                <td>Dec 3 03:20:15 pm</td>
                <td>6Tqwz</td>
              </tr>
              <tr>
                <td>novaHunter</td>
                <td>Buy</td>
                <td>4.333</td>
                <td>12.7m</td>
                <td>Dec 3 03:45:00 pm</td>
                <td>7Yplq</td>
              </tr>
              <tr>
                <td>galaxyMiner</td>
                <td>Sell</td>
                <td>5.765</td>
                <td>16.8m</td>
                <td>Dec 3 04:10:20 pm</td>
                <td>3Apdm</td>
              </tr>
              <tr>
                <td>cosmicTrader</td>
                <td>Buy</td>
                <td>2.458</td>
                <td>6.5m</td>
                <td>Dec 3 04:50:30 pm</td>
                <td>9Kmop</td>
              </tr>
              <tr>
                <td>blockSoldier</td>
                <td>Sell</td>
                <td>3.909</td>
                <td>11.9m</td>
                <td>Dec 3 05:15:40 pm</td>
                <td>2Lpnd</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {activeTab === "Thread" && (
        <div className="thread-tab">
          <div className="thread-card glass-effect">
            <div className="tab-header">
              <div className="avatar-new">
                <img className="tab-avatar" src="/follower.png" alt="Avatar" />
                <span className="tab-username">shinobiTR</span>
              </div>
              <span className="tab-time">12:09 PM</span>
              <img src="/icons/heart.svg" alt="" />
              <button className="tab-reply">Reply</button>
            </div>
            <div className="thread-card-header">
              <img
                className="thread-card-image"
                src="/icons/iconDetail.svg"
                alt="Example"
              />

              <div className="cards-thread">
                <h3 className="thread-card-title">Sadcoon</h3>
                <p className="thread-card-text">
                  A memecoin is a type of cryptocurrency inspired by internet
                  memes, jokes, or cultural trends. Often driven by social media
                  hype and community enthusiasm, these coins typically lack
                  inherent utility or technical innovation compared to major
                  cryptocurrencies like Bitcoin or Ethereum. Popular examples
                  include Dogecoin and Shiba Inu.
                </p>
              </div>
            </div>
          </div>
          {/* Additional thread cards */}
          <div className="thread-card glass-effect">
            <div className="tab-header">
              <div className="avatar-new">
                <img className="tab-avatar" src="/follower.png" alt="Avatar" />
                <span className="tab-username">shinobiTR</span>
              </div>
              <span className="tab-time">12:09 PM</span>
              <img src="/icons/heart.svg" alt="" />
              <button className="tab-reply">Reply</button>
            </div>
            <p className="thread-card-text">
              A memecoin is a type of cryptocurrency inspired by internet memes,
              jokes, or cultural trends. Often driven by social media hype and
              community enthusiasm, these coins...
            </p>
          </div>
          <div className="thread-card glass-effect">
            <div className="tab-header">
              <div className="avatar-new">
                <img className="tab-avatar" src="/follower.png" alt="Avatar" />
                <span className="tab-username">shinobiTR</span>
              </div>
              <span className="tab-time">12:09 PM</span>
              <img src="/icons/heart.svg" alt="" />
              <button className="tab-reply">Reply</button>
            </div>
            <p className="thread-card-text">
              A memecoin is a type of cryptocurrency inspired by internet memes,
              jokes, or cultural trends. Often driven by social media hype and
              community enthusiasm, these coins...
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

const LeftContent = () => {
  const [activeTab, setActiveTab] = useState("buy");
  return (
    <div className="left-content">
      <div className="left-content-top">
        <div className="left-content-top-buttons">
          <button
            className={`button-transparent left-content-button ${
              activeTab === "buy" ? "active-buy" : ""
            }`}
            onClick={() => setActiveTab("buy")}
          >
            Buy
          </button>
          <button
            className={`button-transparent left-content-button ${
              activeTab === "sell" ? "active-sell" : ""
            }`}
            onClick={() => setActiveTab("sell")}
          >
            Sell
          </button>
        </div>
        <div className="set-max-buttons">
          {activeTab === "buy" ? (
            <button className="glass-effect">Switch to Sadcoon</button>
          ) : (
            <span />
          )}
          <button className="glass-effect">Set Max Slippage</button>
        </div>
        <div className="sol-input">
          <div className="left">
            <input type="text" placeholder="0.0" />
          </div>
          <div className="right">
            <h1>SOL</h1>
            <img src={solIcon} />
          </div>
        </div>
        {activeTab === "sell" && (
          <div className="left-content-reset">
            <p>Reset</p>
            <p>0.1 SOL</p>
            <p>0.2 SOL</p>
            <p>0.3 SOL</p>
          </div>
        )}
        <div className="left-content-trade-button">
          <button className="button-purple">Place Trade</button>
        </div>
        <div className="left-content-comment-checkbox">
          <input type="checkbox" />
          <p>Add a Comment</p>
        </div>
      </div>

      <div className="social-buttons">
        <Link to={"/"}>
          <button>
            <img src="/icons/twitter.svg" alt="" />
            Twitter
          </button>
        </Link>
        <Link to={"/"}>
          <button>
            <img src="/icons/telegram.svg" alt="" />
            Telegram
          </button>
        </Link>
        <Link to={"/"}>
          <button>
            <img src="/icons/website.svg" alt="" />
            Website
          </button>
        </Link>
      </div>



      <div className="left-content-bottom">
        <div className="main-private-key">
          <p>ca:</p>
          <div className="private-key-container">
            <input type="text" value={user.privateKey} disabled />
            <div className="copy" onClick={() => handleCopy(user.privateKey)}>
              <img src="/icons/copy.svg" alt="" />
            </div>
          </div>
        </div>
        <div className="sadcoon-cotent">
          <div className="left">
            <img src={sadcoonImage} />
          </div>
          <div className="right">
            <h6>Sadcoon</h6>
            <p>
              A memecoin is a type of cryptocurrency inspired by internet memes,
              jokes, or cultural trends. Often driven by social media hype and
              community enthusiasm, these coins typically lack inherent utility
              or technical innovation compared to major cryptocurrencies like
              Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba
              Inu.
            </p>
          </div>
        </div>
        <div className="curve-proress-bar">
          <h6>
            Bonding Curve Progress: 90%{" "}
            <span>
              <img src="/icons/info.svg" />
            </span>
          </h6>
          <div className="glass-effect inner-bar">
            <div className="outer-bar"></div>
          </div>
          <p>
            Graduate this coin to raydium at $0 market cap there is 0 SOL in the
            bonding curve.
          </p>
        </div>
        <div className="hill-proress-bar">
          <h6>
            King of the Hill Progress: 90%{" "}
            <span>
              <img src="/icons/info.svg" />
            </span>
          </h6>
          <div className="glass-effect inner-bar">
            <div className="hill-outer-bar"></div>
          </div>
          <p>Crowned king of the hill on 12/3/2024, 9:33:25 AM</p>
        </div>
        <div className="main-holder-distribution">
          <h1>Holder Distribution</h1>
          {holderDistributions.map((holderDistribution, index) => (
            <div className="holder-distribution-array" key={index}>
              <div className="right">
                <p>{holderDistribution.serial}</p>
                <p>{holderDistribution.name}</p>
              </div>
              <div className="left">
                <p>{holderDistribution.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const TwoColumnLayout = () => {
  const [showCommentModal, setShowCommentModal] = useState(false);

  return (
    <>
      <div className="two-column-layout">
        <CustomBg />
        <CoinDetails showModal={setShowCommentModal} />
        <LeftContent />
      </div>
      <CommentModal show={showCommentModal} setShow={setShowCommentModal} />
    </>
  );
};

export default TwoColumnLayout;
